module.exports = __webpack_public_path__ + "static/media/star-icon-dark-q.6693f6fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/star-icon-dark-q.svg
// module id = ./src/assets/images/star-icon-dark-q.svg
// module chunks = 0